import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AutomotiveAftermarketProfileItemBriefFacade } from './automotive-aftermarket-profile-item-brief.facade';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketProfileItemBriefGuard {
  constructor(private automotiveAftermarketProfileItemBriefFacade: AutomotiveAftermarketProfileItemBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { automotiveAftermarketProfileId },
    } = route;
    return checkStoreState(this.automotiveAftermarketProfileItemBriefFacade, automotiveAftermarketProfileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.automotiveAftermarketProfileItemBriefFacade);
  }
}
